import { EmploymentTypes, SelectOptionType } from "src/shared/config";
import { employmentLabels } from "src/shared/model";

export const employments: Record<
  EmploymentTypes,
  SelectOptionType<EmploymentTypes>
> = {
  [EmploymentTypes.FULL_TIME]: {
    label: employmentLabels[EmploymentTypes.FULL_TIME],
    value: EmploymentTypes.FULL_TIME,
  },
  [EmploymentTypes.HALF_TIME]: {
    label: employmentLabels[EmploymentTypes.HALF_TIME],
    value: EmploymentTypes.HALF_TIME,
  },
  [EmploymentTypes.REMOTE]: {
    label: employmentLabels[EmploymentTypes.REMOTE],
    value: EmploymentTypes.REMOTE,
  },
  [EmploymentTypes.CONTACT]: {
    label: employmentLabels[EmploymentTypes.CONTACT],
    value: EmploymentTypes.CONTACT,
  },
};
